!(function () {
  const t = {
    init(t) {
      const { sliderSelector: e } = t;
      const container = document.querySelector(
        ".cart-mixmatch:not([data-cart-add-save-root])"
      );
      const sliderEl = document.querySelector(".cart-mixmatch-container");
      if (!container || !sliderEl) return;

      if (this.slider && typeof this.slider.destroy === "function") {
        try {
          this.slider.destroy(true);
        } catch (err) {}
      }

      (this.container = container),
        (this.model = { sliderSelector: e }),
        this.initialSetup(),
        (this.sliderSelector = e),
        (this.sliderDiv = this.container.querySelector(e));
    },
    initialSetup() {
      this.slider = new Splide(".cart-mixmatch-container", {
        fixedWidth: "65%",
        perMove: 1,
        pagination: !1,
        gap: 10,
        classes: {
          arrows: "splide__arrows  custom-splide-arrows",
          arrow: "splide__arrow custom-splide-arrow",
          prev: "splide__arrow--prev custom-splide-arrow--prev",
          next: "splide__arrow--next custom-splide-arrow--next",
        },
      }).mount();
    },
    getModel() {
      return this.model;
    },
  };
  document.addEventListener("DOMContentLoaded", () => {
    t.init({ sliderSelector: ".cart-upsells" });
  });

  const e = {
    show(t, e) {
      t.classList.add(e ?? "d-block");
    },
    hide(t, e) {
      t.classList.remove(e ?? "d-block");
    },
    async addToCart(t) {
      try {
        const e = await fetch("/cart/add.js", {
            ...window.theme.fetchConfig(),
            body: JSON.stringify({
              id: t,
              quantity: 1,
              sections: ["cart-drawer"],
              sections_url: window.location.pathname,
            }),
          }),
          i = await e.text(),
          s = JSON.parse(i);
        s?.sections && window.theme.cart.render(s.sections["cart-drawer"]);
      } catch (t) {
        console.error(t), alert(t.description);
      }
    },
  };

  class i extends HTMLElement {
    constructor() {
      super();
      this.model = {};
      this.select = this.querySelector("select.cart-upsell__select");
      this.addToCartBtn = this.querySelector(".add-to-cart-btn");
      this.pills = [...this.querySelectorAll(".cart-upsell__pill")];
      this.variantOptions = this.select
        ? [...this.select.querySelectorAll("option")]
        : [];

      if (this.hasAttribute("data-pill-options")) {
        this.initPillOptions();
      } else {
        this.initLegacyOptions();
      }
    }

    initPillOptions() {
      this.pills.forEach((pill) => {
        const name = pill.dataset.optionName;
        const selected = pill.querySelector(".cart-upsell__pill-option.is-selected");
        if (name && selected) {
          this.model[name] = selected.dataset.value;
        }

        const trigger = pill.querySelector(".cart-upsell__pill-trigger");
        const menu = pill.querySelector(".cart-upsell__pill-menu");
        if (!trigger || !menu) return;

        menu._pillHome = pill;
        menu.dataset.pillMenu = "true";

        trigger.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.togglePill(pill);
        });

        menu.querySelectorAll(".cart-upsell__pill-option").forEach((optionBtn) => {
          optionBtn.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.selectPillValue(pill, optionBtn);
          });
        });
      });

      if (this.addToCartBtn) {
        this.addToCartBtn.onclick = this.handleAddToCartBtnClick.bind(this);
      }

      this._onPillReposition = () => {
        const openPill = this.pills.find((pill) => pill.classList.contains("is-open"));
        if (!openPill) return;
        const trigger = openPill.querySelector(".cart-upsell__pill-trigger");
        const menu = document.querySelector(
          `.cart-upsell__pill-menu[data-owner="${this._pillOwnerId(openPill)}"]`
        );
        if (trigger && menu && !menu.hidden) {
          this.positionPillMenu(trigger, menu);
        }
      };

      this.syncVariantFromModel();
      this.updatePillAvailability();
    }

    _pillOwnerId(pill) {
      if (!pill.dataset.pillOwnerId) {
        pill.dataset.pillOwnerId = `pill-${Math.random().toString(36).slice(2, 9)}`;
      }
      return pill.dataset.pillOwnerId;
    }

    togglePill(pill) {
      const isOpen = pill.classList.contains("is-open");
      this.closeAllPills();
      if (isOpen) return;

      pill.classList.add("is-open");
      const trigger = pill.querySelector(".cart-upsell__pill-trigger");
      const menu = pill.querySelector(".cart-upsell__pill-menu") ||
        document.querySelector(
          `.cart-upsell__pill-menu[data-owner="${this._pillOwnerId(pill)}"]`
        );
      if (!trigger || !menu) return;

      trigger.setAttribute("aria-expanded", "true");
      menu.dataset.owner = this._pillOwnerId(pill);
      menu._pillHome = pill;
      menu.hidden = false;
      menu.classList.add("is-ported");
      document.body.appendChild(menu);

      requestAnimationFrame(() => {
        this.positionPillMenu(trigger, menu);
      });

      window.addEventListener("resize", this._onPillReposition);
      const scroller = document.querySelector(
        "#cart-drawer .cart-items-wrapper"
      );
      if (scroller) scroller.addEventListener("scroll", this._onPillReposition);
    }

    positionPillMenu(trigger, menu) {
      const rect = trigger.getBoundingClientRect();
      menu.style.visibility = "hidden";
      menu.style.display = "block";
      menu.style.position = "fixed";
      menu.style.top = "0";
      menu.style.left = "0";

      const menuWidth = Math.max(menu.offsetWidth, rect.width, 96);
      const menuHeight = Math.min(menu.scrollHeight, 220);
      const gap = 6;
      const pad = 8;

      // Prefer opening upward so it sits over the product card (matches design)
      let top = rect.top - gap - menuHeight;
      if (top < pad) {
        top = rect.bottom + gap;
      }
      if (top + menuHeight > window.innerHeight - pad) {
        top = Math.max(pad, window.innerHeight - pad - menuHeight);
      }

      let left = rect.left;
      if (left + menuWidth > window.innerWidth - pad) {
        left = window.innerWidth - pad - menuWidth;
      }
      if (left < pad) left = pad;

      menu.style.top = `${Math.round(top)}px`;
      menu.style.left = `${Math.round(left)}px`;
      menu.style.bottom = "auto";
      menu.style.right = "auto";
      menu.style.width = `${Math.round(menuWidth)}px`;
      menu.style.maxHeight = "220px";
      menu.style.zIndex = "2147483000";
      menu.style.visibility = "visible";
    }

    resetPillMenuPosition(menu) {
      if (!menu) return;
      menu.classList.remove("is-ported");
      menu.style.position = "";
      menu.style.top = "";
      menu.style.left = "";
      menu.style.bottom = "";
      menu.style.right = "";
      menu.style.width = "";
      menu.style.maxHeight = "";
      menu.style.zIndex = "";
      menu.style.visibility = "";
      menu.style.display = "";
    }

    closeAllPills() {
      window.removeEventListener("resize", this._onPillReposition);
      const scroller = document.querySelector(
        "#cart-drawer .cart-items-wrapper"
      );
      if (scroller) scroller.removeEventListener("scroll", this._onPillReposition);

      this.pills.forEach((pill) => {
        pill.classList.remove("is-open");
        const trigger = pill.querySelector(".cart-upsell__pill-trigger");
        const ownerId = this._pillOwnerId(pill);
        const menu =
          pill.querySelector(".cart-upsell__pill-menu") ||
          document.querySelector(`.cart-upsell__pill-menu[data-owner="${ownerId}"]`);

        if (trigger) trigger.setAttribute("aria-expanded", "false");
        if (!menu) return;

        menu.hidden = true;
        this.resetPillMenuPosition(menu);
        if (menu._pillHome && menu.parentElement !== menu._pillHome) {
          menu._pillHome.appendChild(menu);
        }
      });
    }

    selectPillValue(pill, optionBtn) {
      const name = optionBtn.dataset.name;
      const value = optionBtn.dataset.value;
      if (!name) return;

      this.model[name] = value;

      const menu =
        optionBtn.closest(".cart-upsell__pill-menu") ||
        pill.querySelector(".cart-upsell__pill-menu") ||
        document.querySelector(
          `.cart-upsell__pill-menu[data-owner="${this._pillOwnerId(pill)}"]`
        );

      (menu ? menu.querySelectorAll(".cart-upsell__pill-option") : []).forEach(
        (btn) => {
          const selected = btn === optionBtn;
          btn.classList.toggle("is-selected", selected);
          btn.setAttribute("aria-selected", selected ? "true" : "false");
        }
      );

      if (pill.classList.contains("cart-upsell__pill--color")) {
        const swatch = pill.querySelector("[data-pill-swatch]");
        if (swatch) {
          swatch.className =
            "cart-upsell__pill-swatch color-input color-" +
            value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
        }
      } else {
        const valueEl = pill.querySelector("[data-pill-value]");
        if (valueEl) valueEl.textContent = value;
      }

      this.syncVariantFromModel();
      this.updatePillAvailability();
      this.closeAllPills();
    }

    syncVariantFromModel() {
      if (!this.select) return;

      const title = this.getVariantTitle();
      let selected = this.variantOptions.find(
        (option) =>
          !option.disabled &&
          !option.classList.contains("d-none") &&
          option.textContent.trim() === title
      );

      if (!selected) {
        selected = this.variantOptions.find((option) => {
          if (option.disabled || option.classList.contains("d-none")) return false;
          const values = [
            option.dataset.option1,
            option.dataset.option2,
            option.dataset.option3,
          ].filter((v) => v != null && v !== "");

          if (values.length !== Object.keys(this.model).length) return false;
          return values.every((value) => Object.values(this.model).includes(value));
        });
      }

      if (!selected) {
        this.disableAtc();
        return;
      }

      this.enableAtc();
      this.select.value = selected.value;
      this.select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    getVariantTitle() {
      return this.pills
        .map((pill) => this.model[pill.dataset.optionName])
        .filter(Boolean)
        .join(" / ");
    }

    updatePillAvailability() {
      this.pills.forEach((pill) => {
        const name = pill.dataset.optionName;
        const menu =
          pill.querySelector(".cart-upsell__pill-menu") ||
          document.querySelector(
            `.cart-upsell__pill-menu[data-owner="${this._pillOwnerId(pill)}"]`
          );
        if (!menu) return;

        menu.querySelectorAll(".cart-upsell__pill-option").forEach((btn) => {
          const value = btn.dataset.value;
          const available = this.variantOptions.some((option) => {
            if (option.disabled || option.classList.contains("d-none")) return false;

            const optionValues = [
              option.dataset.option1,
              option.dataset.option2,
              option.dataset.option3,
            ];

            if (!optionValues.includes(value)) return false;

            return Object.entries(this.model).every(([modelName, modelValue]) => {
              if (modelName === name) return true;
              return optionValues.includes(modelValue);
            });
          });

          // Only show available options in the menu
          btn.hidden = !available;
          btn.disabled = !available;
          btn.classList.toggle("is-unavailable", !available);
          btn.style.display = available ? "" : "none";
        });
      });
    }

    async handleAddToCartBtnClick() {
      const { addToCart } = e;
      const id = this.select?.value;
      if (!id) return;
      this.disableAtc();
      await addToCart(id);
      this.enableAtc();
    }

    disableAtc() {
      if (this.addToCartBtn) this.addToCartBtn.disabled = true;
    }

    enableAtc() {
      if (this.addToCartBtn) this.addToCartBtn.disabled = false;
    }

    // Legacy multi-step swatch flow (kept for any non-pill markup)
    initLegacyOptions() {
      this.optionsView = this.querySelector(".cart-upsell__options-box");
      if (!this.optionsView || !this.select) {
        if (this.addToCartBtn) {
          this.addToCartBtn.onclick = this.handleAddToCartBtnClick.bind(this);
        }
        return;
      }

      this.colorsView = this.optionsView.querySelector(
        ".cart-upsell__swatches-box--colors"
      );
      this.secondaryOptionsView = this.optionsView.querySelector(
        ".cart-upsell__swatches-box:not(.cart-upsell__swatches-box--colors)"
      );
      this.pickColorBtn = this.querySelector(".pick-color-btn");
      this.arrowBtn = this.querySelector(".arrow-btn");
      this.backBtn = this.querySelector(".back-btn");
      this.colorSwatches = this.colorsView
        ? [...this.colorsView.querySelectorAll("input")]
        : [];
      this.secondarySwatches = this.secondaryOptionsView
        ? [...this.secondaryOptionsView.querySelectorAll("input")]
        : [];
      this.model = { color: null };

      this.optionsView.oninput = this.handleOptionsViewInput.bind(this);
      if (this.pickColorBtn) {
        this.pickColorBtn.onclick = this.handlePickColorBtnClick.bind(this);
      }
      if (this.addToCartBtn) {
        this.addToCartBtn.onclick = this.handleAddToCartBtnClick.bind(this);
      }
      if (this.backBtn) {
        this.backBtn.onclick = this.handleBackBtnClick.bind(this);
      }
      if (this.arrowBtn) {
        this.arrowBtn.onclick = this.handleArrowBtnClick.bind(this);
      }
      this.hideUnavailableOptions();
    }

    handleOptionsViewInput(t) {
      const { target: el } = t;
      const action = el?.dataset?.action;
      if (!action) return;
      if (action === "select-color") this.handleColorSelection(el);
      if (action === "select-option") this.handleSecondaryOptionSelection(el);
    }

    handleColorSelection(el) {
      const { show, hide } = e;
      this.model.color = el.value;
      this.hideUnavailableSecondaryOptions();
      const visibleSecondary = this.secondaryOptionsView
        ? this.secondaryOptionsView.querySelectorAll("label.d-inline")
        : [];
      if (visibleSecondary.length > 1) {
        hide(this.colorsView);
        show(this.secondaryOptionsView);
      } else if (this.secondaryOptionsView) {
        const input = this.secondaryOptionsView.querySelector(
          "label.d-inline"
        )?.previousElementSibling;
        if (input) {
          this.model[input.dataset.name] = input.value;
          this.selectOption(this.getLegacyVariantTitle());
        }
      }
      show(this.addToCartBtn.parentNode);
    }

    handleSecondaryOptionSelection(el) {
      this.model[el.dataset.name] = el.value;
      this.selectOption(this.getLegacyVariantTitle());
    }

    handlePickColorBtnClick() {
      const { show, hide } = e;
      show(this.optionsView);
      show(this.colorsView);
      hide(this.pickColorBtn.parentNode);
    }

    handleBackBtnClick() {
      const { show, hide } = e;
      hide(this.secondaryOptionsView);
      show(this.colorsView);
      hide(this.addToCartBtn.parentNode);
    }

    handleArrowBtnClick() {
      const { show, hide } = e;
      hide(this.optionsView);
      hide(this.colorsView);
      hide(this.addToCartBtn.parentNode);
      show(this.pickColorBtn.parentNode);
    }

    getLegacyVariantTitle() {
      return Object.values(this.model).reduce(
        (title, value) => (title ? `${title} / ${value}` : value),
        ""
      );
    }

    selectOption(title) {
      const option = this.variantOptions.find(
        (el) => el.textContent.trim() === title
      );
      if (!option) {
        this.disableAtc();
        return;
      }
      this.enableAtc();
      this.select.value = option.value;
      this.select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    hideUnavailableOptions() {
      const { show, hide } = e;
      this.colorSwatches.forEach((input) => {
        const matches = this.variantOptions.some(
          (option) =>
            option.textContent.includes(input.value) &&
            parseInt(option.dataset.inventory)
        );
        matches
          ? show(input.nextElementSibling, "d-inline")
          : hide(input.nextElementSibling, "d-inline");
      });
      this.secondarySwatches.forEach((input) => {
        const matches = this.variantOptions.some(
          (option) =>
            option.textContent.includes(input.value) &&
            parseInt(option.dataset.inventory)
        );
        matches
          ? show(input.nextElementSibling, "d-inline")
          : hide(input.nextElementSibling, "d-inline");
      });
    }

    hideUnavailableSecondaryOptions() {
      const { show, hide } = e;
      this.secondarySwatches.forEach((input) => {
        const matches = this.variantOptions.some(
          (option) =>
            option.textContent.includes(input.value) &&
            option.textContent.includes(this.model.color) &&
            parseInt(option.dataset.inventory)
        );
        matches
          ? show(input.nextElementSibling, "d-inline")
          : hide(input.nextElementSibling, "d-inline");
      });
    }
  }

  customElements.define("cart-upsell", i), (Shopify.cartUpsellsApp = t);

  document.addEventListener("click", (event) => {
    if (
      event.target.closest(".cart-upsell__pill") ||
      event.target.closest(".cart-upsell__pill-menu")
    ) {
      return;
    }
    document.querySelectorAll("cart-upsell[data-pill-options]").forEach((el) => {
      if (typeof el.closeAllPills === "function") el.closeAllPills();
    });
  });
})();
